import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/pages/Homepage'
import Home from '@/pages/Home'
import Product from '@/pages/Product'
import Introduction from '@/pages/Introduction'
import News from '@/pages/News'
import Contact from '@/pages/Contact'
import NewsContent from '@/pages/NewsContent'
import Partner from '@/pages/Partner'
import Disclosure from '@/pages/Disclosure'
import Lpfw from '@/pages/Lpfw'
import Cpfz from '@/pages/Cpfz'
import License from '@/pages/License'
import Cooperative from '@/pages/Cooperative'
Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savePostion) {
    // console.log('---> to', to.path)
    // console.log('---> from', from.path)
    console.log('----> savePostion', savePostion)
  if (to.path === '/news' && from.path === '/newsContent') {
    return savePostion
  } else {
    return {
      x: 0,
      y: 0
    }
  }
  },
  routes: [{
      path: '/',
      name: 'Homepage',
      component: Homepage,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'Home',
          component: Home,
          meta: {
            keepAlive: false
          }
        },
        {
          path: '/product',
          name: 'Product',
          component: Product,
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/introduction',
          name: 'Introduction',
          component: Introduction,
          meta: {
            keepAlive: false
          }
        },
        {
          path: '/news',
          name: 'News',
          component: News,
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/contact',
          name: 'Contact',
          component: Contact,
          meta: {
            keepAlive: false
          }
        },
        {
          path: '/newsContent',
          name: 'NewsContent',
          component: NewsContent,
          meta: {
            keepAlive: false
          }
        },
        {
          path: '/partner',
          name: 'Partner',
          component: Partner,
          meta: {
            keepAlive: false
          }
        },
        {
          path: '/disclosure',
          name: 'Disclosure',
          component: Disclosure,
          meta: {
            keepAlive: false
          }
        },
        {
          path: '/lpfw',
          name: 'Lpfw',
          component: Lpfw,
          meta: {
            keepAlive: false
          }
        },
        {
          path: '/cpfz',
          name: 'Cpfz',
          component: Cpfz,
          meta: {
            keepAlive: false
          }
        },
        {
          path: '/cooperative',
          name: 'Cooperative',
          component: Cooperative,
          meta: {
            keepAlive: false
          }
        }
      ]
    },
    {
      path: '/license',
      name: 'License',
      component: License
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js